import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaypal } from '@fortawesome/free-brands-svg-icons';
import './Commission.scss';

const Commission = () => {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="commission-container">
      <div className="commission-header">
        <h1>Commissions</h1>
        <p>Découvrez mes services et tarifs pour des emotes personnalisées</p>
      </div>

      <div className="pricing-section">
        <div className="pricing-card">
          <h2>Emote Simple</h2>
          <div className="price">5€</div>
          <ul>
            <li>Design simple</li>
            <li>1 révision incluse</li>
            <li>Format Twitch/Discord/Youtube/Tiktok</li>
            <li>Délai : 2-3 jours</li>
          </ul>
        </div>

        <div className="pricing-card featured">
          <div className="featured-badge">Populaire</div>
          <h2>Emote Animée</h2>
          <div className="price">10€</div>
          <ul>
            <li>Design animée</li>
            <li>1 révision incluse</li>
            <li>Format Twitch/Discord/Youtube/Tiktok</li>
            <li>Délai : 3-5 jours</li>
          </ul>
        </div>

        <div className="pricing-card">
          <h2>Pack Emotes</h2>
          <div className="price">25€</div>
          <ul>
            <li>Pack de 5 emotes</li>
            <li>1 révision par emote</li>
            <li>Format Twitch/Discord/Youtube/Tiktok</li>
            <li>Délai : 1-2 semaines</li>
          </ul>
        </div>
      </div>

      <div className="payment-section">
        <h2>Effectuer un paiement</h2>
        <p>Pour commander ou faire un don, utilisez PayPal :</p>
        <a 
          href="https://www.paypal.com/paypalme/judcoco?locale.x=fr_F" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="paypal-button"
        >
          <FontAwesomeIcon icon={faPaypal} />
          Payer avec PayPal
        </a>
      </div>

      <div className="terms-section">
        <h2>Conditions</h2>
        <ul>
          <li>Paiement à l'avance requis</li>
          <li>Les délais peuvent varier selon la charge de travail</li>
          <li>Révisions supplémentaires : 5€ chacune</li>
          <li>Droits d'auteur transférés après paiement complet</li>
        </ul>
      </div>

      <div className="contact-section">
        <h2>Contact</h2>
        <p>Pour toute demande de commission ou question :</p>
        <Link to="/contact" className="contact-button" onClick={scrollToTop}>
          Me contacter
        </Link>
      </div>
    </div>
  );
};

export default Commission;